module.exports = __webpack_public_path__ + "img/91.71ddf1ea.jpg";